import { VehicleFeature } from '@/catalog/types/vehicle';
import { useMemo } from 'react';
import { uniqBy } from 'lodash-es';

const MOBILE_SPEC_KEYS = ['fuel_type', 'mpg', 'drive_train', 'engine_type', 'wheels'];

export function useMobileSpecifications(
  groupedSpecifications?: Record<string, VehicleFeature[]>
) {
  return useMemo(() => {
    if (!groupedSpecifications || !Object.keys(groupedSpecifications).length) {
      return [];
    }

    const flatSpecs = Object.values(groupedSpecifications).flat();

    const filteredSpecs = flatSpecs.filter((spec) => MOBILE_SPEC_KEYS.includes(spec.key));

    // If we need more specs, add them from flatSpecs sorted by ranking value
    if (filteredSpecs.length < MOBILE_SPEC_KEYS.length) {
      const neededSpecsCount = 5 - filteredSpecs.length;
      const additionalSpecs = flatSpecs
        .sort((a, b) => (a.ranking_value ?? 0) - (b.ranking_value ?? 0))
        .filter((spec) => !filteredSpecs.some((filtered) => filtered.key === spec.key))
        .slice(0, neededSpecsCount);

      return uniqBy([...filteredSpecs, ...additionalSpecs], 'key'); // Ensure no duplicates
    }

    return filteredSpecs;
  }, [groupedSpecifications]);
}
